import { __awaiter, __generator } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useDownloadPopover } from "./hooks";
import PasswordConfirmationModal from "../PasswordConfirmationModal";
export default function DownloadPopover() {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var download = useDownloadPopover();
    useEffect(function () {
        useDownloadPopover.setState({
            download: undefined,
            onDone: undefined,
            onCancel: undefined,
        });
    }, []);
    var handleClose = function () {
        if (!!download.onCancel)
            download.onCancel();
        useDownloadPopover.setState({
            download: undefined,
            onDone: undefined,
            onCancel: undefined,
        });
    };
    var algo = (_e = (_b = (_a = download.download) === null || _a === void 0 ? void 0 : _a["vault-password-algorithm"]) !== null && _b !== void 0 ? _b : (_d = (_c = download === null || download === void 0 ? void 0 : download.download) === null || _c === void 0 ? void 0 : _c.metadata_protected) === null || _d === void 0 ? void 0 : _d["vault-password-algorithm"]) !== null && _e !== void 0 ? _e : "AES-CFB-256";
    return (_jsx("div", { children: _jsx(PasswordConfirmationModal, { open: !!(download === null || download === void 0 ? void 0 : download.download), onContinue: function (password) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, !!(download === null || download === void 0 ? void 0 : download.onDone) && download.onDone(password, algo)];
            }); }); }, onClose: handleClose, title: "Download file", description: "File requires a password to download" }) }));
}
